import * as React from 'react';
import { Link as MuiLink } from '@mui/material';
import { TLink } from './Link.types';
import './Link.styles.scss';

export const Link: TLink = ({ children, ...props }) => {
  return (
    <MuiLink className="link" underline="hover" {...props}>
      {children}
    </MuiLink>
  );
};
